import { render, staticRenderFns } from "./subproject-group.vue?vue&type=template&id=0651b80a"
import script from "./subproject-group.vue?vue&type=script&lang=js"
export * from "./subproject-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports